// extracted by mini-css-extract-plugin
export default {"fixedHeightColumn":"_3saU0"};